/**
 * First-focusable skip link for keyboard users (WCAG 2.4.1).
 */
export default function SkipLink() {
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[200] focus:rounded-md focus:bg-background-primary focus:px-4 focus:py-3 focus:font-body focus:text-md focus:font-semibold focus:text-text-primary-900 focus:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-foreground-brand-solid"
    >
      Skip to main content
    </a>
  )
}
